import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;

const AggregationInfoChartActions = {
    getAggregationInfo(params, callback) {
        dispatch({
            type: AppConstants.AGGREGATION_INFO_START_LOADING
        });

        return api.getAggregationInfo()
            .then(data => {
                dispatch({
                    type: AppConstants.AGGREGATION_INFO_SUCCESS,
                    item: data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.AGGREGATION_INFO_FAIL,
                        error: err
                    });
                });
            });
    }
};

export default AggregationInfoChartActions;
